"use strict";
/* tslint:disable */
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
//==============================================================
// START Enums and Input Objects
//==============================================================
var Option;
(function (Option) {
    Option["option1"] = "option1";
    Option["option2"] = "option2";
    Option["option3"] = "option3";
})(Option = exports.Option || (exports.Option = {}));
var Plan;
(function (Plan) {
    Plan["implicit_trial"] = "implicit_trial";
    Plan["monthly"] = "monthly";
    Plan["yearly"] = "yearly";
})(Plan = exports.Plan || (exports.Plan = {}));
var PlanStatus;
(function (PlanStatus) {
    PlanStatus["active"] = "active";
    PlanStatus["cancelled"] = "cancelled";
    PlanStatus["declined"] = "declined";
    PlanStatus["expired"] = "expired";
    PlanStatus["frozen"] = "frozen";
    PlanStatus["pending"] = "pending";
})(PlanStatus = exports.PlanStatus || (exports.PlanStatus = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
